var AdaptiveImage = require("../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-fly-pha-cmr.59ef040b.png","uri@2x": __webpack_public_path__ + "icon-fly-pha-cmr.d8759b8a.png","uri@3x": __webpack_public_path__ + "icon-fly-pha-cmr.998055b6.png",
    width: 20,
    height: 20
});